import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Spinner from '../../../global/components/helpers/Spinner.jsx'

const FullScreenModule = ({ src, handleClose }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    return () => setIsLoaded(false)
  }, [src])

  if(!src) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50">
      {!isLoaded && (
        <div className="absolute inset-0 flex justify-center items-center">
          <Spinner />
        </div>
      )}
      <div className='h-[100vh] rounded-lg w-full sm:h-[95vh] sm:max-w-[90vw] p-4 sm:mt-4 relative mx-auto overflow-auto bg-white'>
        <div className="flex w-full">
          <button className="ml-auto flex btn-xs btn-tertiary p-2" onClick={handleClose}><i className="fa fa-times h-4 w-4 text-base text-inherit" /></button>
        </div>
        <iframe src={src} allowFullScreen={true} className={`w-full h-[calc(100%-34px)] max-h-full ${isLoaded ? 'opacity-100' : 'opacity-0'}`} onLoad={() => setIsLoaded(true)} />
      </div>
    </div>
  )
}

FullScreenModule.propTypes = {
  src: PropTypes.string
  , handleClose: PropTypes.func.isRequired
}

export default FullScreenModule;